import { render } from "./SheetSongBaseForm.vue?vue&type=template&id=161567bf&scoped=true"
import script from "./SheetSongBaseForm.vue?vue&type=script&lang=ts"
export * from "./SheetSongBaseForm.vue?vue&type=script&lang=ts"

import "./SheetSongBaseForm.vue?vue&type=style&index=0&id=161567bf&lang=css"
import "./SheetSongBaseForm.vue?vue&type=style&index=1&id=161567bf&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-161567bf"

export default script